// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export enum Capability {
  ContactsReadAll = "contacts.read.all",
  CommunicationsReadAll = "communications.read.all",
  TeamManage = "team.manage",
  BillingManage = "billing.manage",
  ConnectorsManage = "connectors.manage",
  TemplatesManage = "templates.manage",
  DocumentsManage = "documents.manage",
  DelegationsAssign = "delegations.assign",
  ContactsMerge = "contacts.merge",
  ContactsWrite = "contacts.write",
  CommunicationsTriage = "communications.triage",
  CommunicationsSend = "communications.send",
}

export const CAPABILITY_VALUES: readonly Capability[] = Object.values(Capability);

export function isCapability(value: string): value is Capability {
  return CAPABILITY_VALUES.includes(value as Capability);
}
